import { useCallback, useState } from 'react';

import { TTab } from '@/components/global/Tabs/Tab';

import { TRecommendation } from '@/services/requests/Recommendation/types/template5';

import { getValue } from '@/helpers/GetValueHelper';

const useTabs = (data: TRecommendation[]) => {
  const [tabItems, setTabItems] = useState<TTab[]>(() => {
    return data.map((item, index) => ({
      id: item.idLiferay,
      key: item.idLiferay,
      label: (item.info && item.info.text) || item.idLiferay,
      viewed: false,
      active: index === 0,
      recommendationId: item.idLiferay,
    }));
  });

  const handleTabClick = useCallback((param: string) => {
    setTabItems(prev => {
      return prev.map(item => {
        return {
          ...item,
          active: item.id === param,
        };
      });
    });
  }, []);

  const getTabActive = () => {
    const item = tabItems.find(tabItem => tabItem.active);
    return getValue(item, 'id', '');
  };
  return {
    tabItems,
    getTabActive,
    onTabClick: handleTabClick,
  };
};

export default useTabs;
